
import { Group } from '../../types';
import { KEYS, get, set } from '../core';

// Local storage functions
export const getGroups = (): Group[] => get<Group>(KEYS.GROUPS);
export const setGroups = (groups: Group[]): void => set(KEYS.GROUPS, groups);

